module.exports = __webpack_public_path__ + "static/img/年度最佳洗衣机.07e931e4.png";